import React from "react";

import { Button } from "@brexhq/next/src/components/shared/Button";
import type { RebirthButtonProps } from "@brexhq/next/src/components/shared/Button/types";
import { VideoModal } from "@brexhq/next/src/components/shared/VideoModal/VideoModal";
import type { IBynderVideoWithCaption } from "@brexhq/shared/types/BynderAsset";

export const VideoButton: React.FC<{
  video: IBynderVideoWithCaption;
  label: React.ReactNode;
  topMargin: number;
  /**
   * Used to identify what component emitted an analytics event
   */
  componentName?: string;
  section?: string;
  modifier?: "default" | "unstyled";
  lightMode?: boolean;
  maxWidth?: string;
}> = ({
  video,
  label,
  topMargin,
  componentName = "TextRows",
  modifier = "default",
  section = "Video Play Button",
  lightMode = false,
  maxWidth,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const videoModal = video?.video?.videoUrl && (
    <VideoModal
      src={video.video.videoUrl}
      posterImageSrc={video.video.previewImg || ""}
      captionFile={video.captions?.asset?.url}
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      lightMode={lightMode}
      maxWidth={maxWidth}
    />
  );
  const props: RebirthButtonProps = {
    testId: "playButton",
    modifier: "unstyled",
    label,
    section,
    component: componentName,
    margin: [topMargin, 0, 0, 0],
    onClick: () => setIsOpen(true),
  };

  switch (modifier) {
    case "default":
      return (
        <>
          {videoModal}
          <Button
            section="Video Play Button"
            {...props}
            modifier="primary"
            icon="VideoPlayPlain"
            iconSize="sml"
          />
        </>
      );

    case "unstyled":
      return (
        <>
          {videoModal}
          <Button {...props} modifier="unstyled" />
        </>
      );
  }
};
